import { Copy } from "lucide-react"
import { Button } from "~/ui/button"
import { cn } from "~/common/cn"

interface WalletDisplayProps {
  publicKey: string
  publicKeyFormatted: string
  showVerified?: boolean
  showFullAddress?: boolean
  className?: string
}

export const WalletDisplay = ({
  publicKey,
  publicKeyFormatted,
  showVerified = false,
  showFullAddress = false,
  className,
}: WalletDisplayProps) => {
  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation()
    navigator.clipboard.writeText(publicKey)
  }

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <span className={showFullAddress ? "break-all font-mono text-sm" : ""}>
        {showFullAddress ? publicKey : publicKeyFormatted}
      </span>
      <Button
        variant="ghost"
        size="icon"
        onClick={handleCopy}
        className="h-6 w-6 text-gray-400 hover:text-gray-600"
        title="Copy wallet address"
      >
        <Copy size={14} />
      </Button>
      {showVerified && <span className="text-sm text-blue-600">verified</span>}
    </div>
  )
}
